'use strict';

import React from 'react';
import Animation from 'ck-core-client/source/ui/Animation';
import PropTypes from 'prop-types';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';

export default class HowItWorksColumn extends React.Component {
	render() {
		return (
			<div className="HowItWorksColumn col-sm-4">
				{this.props.animation && (
					<Animation name={this.props.animation} loop={true} playOnHover={true} />
				)}
				{this.props.image && <ReactCKImage name={this.props.image} />}
				<h3 className="title"> {this.props.title} </h3>
				<div className="explanation"> {this.props.explanation} </div>
			</div>
		);
	}
}

HowItWorksColumn.propTypes = {
	title: PropTypes.string.isRequired,
	explanation: PropTypes.string.isRequired,
	animation: PropTypes.string,
	image: PropTypes.string
};
